import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error"
}

import {useAuthErrors} from '@/hooks/useAuthErrors';
import {createNamespacedHelpers} from 'vuex-composition-helpers';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheAuthErrorsIndicator',
  setup(__props) {

const { useGetters } = createNamespacedHelpers('authModule');

const { getError } = useGetters(['getError']);
const errorMessage = useAuthErrors();

return (_ctx: any,_cache: any) => {
  return (_unref(getError).isError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Произошла ошибка: " + _toDisplayString(_unref(errorMessage)), 1))
    : _createCommentVNode("", true)
}
}

})